import { StreamInfo } from './Streams';
import React from 'react';
import LabelValue from 'utils/components/LabelValue/LabelValue';
import DetailPanel from 'widgets/supportVisualisation/Content/DetailPanel';
import { toDateString } from 'widgets/supportVisualisation/SupportVisualisationHelpers';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import {
    NotificationType,
    ToolbarIcon,
} from '@instinet-analytics/semantic-ui-components';
import useCopy from '@react-hook/copy';
import { useDispatchShowNotification } from 'notification/store/dispatcher';

export interface StreamPanelProps {
    stream: StreamInfo;
    width: number;
    onClickClose: () => void;
}

export default function StreamPanel(props: StreamPanelProps) {
    const { stream, width, onClickClose } = props;
    const showNotification = useDispatchShowNotification();

    const { copy } = useCopy(JSON.stringify(stream.payload));

    const onClick = () => {
        copy().then(() => {
            showNotification('Copied to clipboard', NotificationType.Info);
        });
    };

    return (
        <DetailPanel className="StreamPanel" width={width}>
            <div className="close-button" onClick={() => onClickClose()}>
                <Icon name="close" />
            </div>
            <div className="info">
                <LabelValue label="Channel Id" value={stream.channelId} />
                <LabelValue label="Request Id" value={stream.requestId} />
                <LabelValue
                    label="Correlation Id"
                    value={stream.correlationId}
                />
                <LabelValue label="Time" value={toDateString(stream.time)} />
                <LabelValue label="Type" value={stream.type} />
                {stream.responses && (
                    <LabelValue
                        label="Responses"
                        value={`${stream.responses}`}
                    />
                )}
            </div>
            <div className="payload-container">
                <div className="payload">{JSON.stringify(stream.payload)}</div>
                <ToolbarIcon
                    name="clipboard outline"
                    active={true}
                    onClick={onClick}
                />
            </div>
        </DetailPanel>
    );
}
